import { Component, effect, inject, OnInit } from '@angular/core';
import { BookmarkStore } from '../../../stores/bookmark/bookmark.state';
import { BookmarkCategory } from '../../../models/bookmark-category';
import { Bookmark } from '../../../models/bookmark';
import { AccordionModule } from 'primeng/accordion';
import { AlertComponent } from '../../atoms/alert/alert.component';
import { AlertStyleDirective } from '../../../directives/alert-style.directive';
import { BadgeModule } from 'primeng/badge';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DividerModule } from 'primeng/divider';
import { HeaderComponent } from '../../atoms/header/header.component';
import { StoryStore } from '../../../stores/story/story.state';
import { Story } from '../../../models/story';
import { BookmarkCategoryStore } from '../../../stores/bookmark-category/bookmark-category.state';
import { getState } from '@ngrx/signals';
import { BookmarkCategoryHelperService } from '../../../services/bookmark-category/bookmark-category-helper.service';

@Component({
  selector: 'app-confirm-delete-bookmark-category',
  standalone: true,
  imports: [
    AccordionModule,
    AlertComponent,
    AlertStyleDirective,
    BadgeModule,
    ButtonModule,
    ConfirmDialogModule,
    DividerModule,
    HeaderComponent,
  ],
  templateUrl: './confirm-delete-bookmark-category.component.html',
  styleUrl: './confirm-delete-bookmark-category.component.scss',
})
export class ConfirmDeleteBookmarkCategoryComponent implements OnInit {
  readonly bookmarkCategoryStore = inject(BookmarkCategoryStore);
  readonly bookmarkStore = inject(BookmarkStore);
  readonly storyStore = inject(StoryStore);
  readonly bookmarkCategoryHelper = inject(BookmarkCategoryHelperService);

  bookmarkCategoryToDelete: BookmarkCategory | null = null;
  categoryBookmarks: Bookmark[] = [];
  categoryStories: Story[] = [];

  constructor() {
    effect(() => {
      const categoryState = getState(this.bookmarkCategoryStore);
      this.bookmarkCategoryToDelete = this.bookmarkCategoryStore.selectedItem();
      this.checkForData();
    });
  }

  /**
   * Lifecycle hook that is called after Angular has initialized all data-bound properties and the component's view.
   * Typically used to perform initialization logic, such as fetching or setting up data.
   *
   * @return {void} Does not return a value.
   */
  ngOnInit(): void {
    this.checkForData();
  }

  /**
   * Checks for data associated with the category to delete.
   * Updates categoryBookmarks and categoryStories based on the category's ID.
   *
   * @return {void} This method does not return a value.
   */
  checkForData(): void {
    if (!this.bookmarkCategoryToDelete) return;
    this.categoryBookmarks = this.bookmarkCategoryHelper.getBookmarksForCategory(
      this.bookmarkCategoryToDelete._id
    );
    this.categoryStories =
      this.storyStore.groupedByCategory()?.[this.bookmarkCategoryToDelete._id];
  }
}
